/**
 * Skeleton — Pulsing placeholder shown while content is loading.
 *
 * Skeleton Component Guidelines
 * - Use Skeleton when the layout of the loaded content is known ahead of time —
 *   match the skeleton's dimensions (width, height, border-radius) to the actual
 *   content for a smooth transition when data arrives.
 * - Prefer Skeleton over Spinner when multiple pieces of content load independently
 *   (e.g. a card grid) — it reduces layout shift and feels faster.
 * - Use Spinner instead when the loading area has no predictable layout (e.g.
 *   indeterminate full-page loads).
 * @see https://ui.shadcn.com/docs/components/skeleton shadcn/ui Skeleton documentation
 */
import React from "react";

import twMerge from "../../utils/twMerge";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={twMerge("bg-surface rounded-md animate-pulse", className)}
      {...props}
    />
  );
}

export { Skeleton };
